import { Box, BoxProps } from '@mui/material';
import { Fragment, memo } from 'react';
import jsonExport from 'jsonexport/dist';
import { ArrayField, BulkDeleteButtonProps, BulkExportButton, BulkExportButtonProps, Datagrid, DateField, downloadCSV, EditButton, List, ReferenceOneField, ShowButton, ShowView, SimpleShowLayout, SingleFieldList, TextField, TextInput } from 'react-admin';
import AlertDateField from '../../Components/AlertDateField';

const CustomersListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const CustomersListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (users: any[]) => {
  return jsonExport(users, (err: Error, csv: string) => downloadCSV(csv, 'users'));
};
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const CustomersPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="email" />
        <TextField source="location.name" />
        <TextField source="externalId" label="External ID" />
        <ReferenceOneField reference="organizations" source="organizationUuid" target="uuid">
          <TextField source="name" />
        </ReferenceOneField>
        <ArrayField source="companies" label="Companies">
          <SingleFieldList>
            <TextField source="companyUuid" />
          </SingleFieldList>
        </ArrayField>
        <ArrayField source="subscriptions">
          <Datagrid>
            <TextField source="uuid" />
            <TextField source="externalId" label="External ID" />
            <TextField source="status" />
            <DateField source="startedAt" />
            <DateField source="currentPeriodStartedAt" />
            <DateField source="currentPeriodEndedAt" />
            <DateField source="trialStartedAt" />
            <AlertDateField source="trialEndedAt" />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </ShowView>
  );
};
const usersFilter = [<TextInput label="Name" source="name" alwaysOn />, <TextInput label="Uuid" source="uuid" alwaysOn />, <TextInput label="Company uuid" source="companyUuid" alwaysOn />];
const CustomersList: React.FC = () => {
  return (
    <List exporter={exporter} filters={usersFilter}>
      <Datagrid bulkActionButtons={<CustomersListBulkActions />} rowClick={rowClick} expand={CustomersPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="rawLocation" label="Location" />
        <TextField source="location.code" />
        <TextField source="externalId" label="External ID" />
        <ReferenceOneField reference="organizations" source="organizationUuid" target="uuid">
          <TextField source="uuid" />
        </ReferenceOneField>
        <ArrayField source="subscriptions" label="Subscription uuid">
          <SingleFieldList>
            <TextField source="uuid" />
          </SingleFieldList>
        </ArrayField>
        <ArrayField source="subscriptions" label="Trail End">
          <SingleFieldList>
            <AlertDateField source="trialEndedAt" />
          </SingleFieldList>
        </ArrayField>
        <CustomersListActionToolbar>
          <EditButton />
          <ShowButton />
        </CustomersListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default CustomersList;
